export const stripeSecretKey = 'sk_test_51MhAv2EZcxdpQrLzfMFWZAYEFGtKlvKt6zLiHiDMvEDMbMzE5E32e5zxc5zLYOSJV01nZxsNWSJAxxVa13H8gKcl00Bl3Ck8Rt'